/**
 * The icon paths, as data.
 *
 * Hand-drawn rather than pulled from `lucide-react` for the same reason the
 * reader's are — these come from the design system's own mock, and matching
 * them exactly is cheaper than finding the nearest library glyph and
 * explaining the difference later.
 *
 * Data, not components, so the file can be imported by both the drawing
 * component and the pure helpers that choose a name.
 */
export const ICON_PATHS = {
  pdf: 'M7 3h7l4 4v14H7zM14 3v4h4M9.5 12h5M9.5 15.5h5',
  doc: 'M7 3h7l4 4v14H7zM14 3v4h4M9.5 11h5M9.5 14h5M9.5 17h3',
  txt: 'M5 4h14v16H5zM8 8h8M8 12h8M8 16h5',
  alert: 'M12 4l9 16H3zM12 10v4M12 17.5h.01',
  check: 'M5 12.5l4.5 4.5L19 7.5',
  clock: 'M12 4a8 8 0 1 0 0 16 8 8 0 0 0 0-16zM12 8v4.5l3 2',
  refresh: 'M20 12a8 8 0 1 1-2.3-5.7M20 4v4.5h-4.5',
  link: 'M10 14a3.5 3.5 0 0 0 5 0l3-3a3.5 3.5 0 0 0-5-5l-1 1M14 10a3.5 3.5 0 0 0-5 0l-3 3a3.5 3.5 0 0 0 5 5l1-1',
  upload: 'M12 16V5M7.5 9.5 12 5l4.5 4.5M5 19h14',
  publisher: 'M3 10l9-5 9 5zM5 10v7M9.5 10v7M14.5 10v7M19 10v7M3 20h18',
  calendar: 'M4 7h16v13H4zM4 11h16M8 3v4M16 3v4',
  close: 'M6 6l12 12M18 6 6 18',
  info: 'M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18zM12 11v5M12 8h.01',
  chevron: 'm6 9.5 6 6 6-6',
  sparkle: 'M12 3l1.8 5.2L19 10l-5.2 1.8L12 17l-1.8-5.2L5 10l5.2-1.8L12 3z',
} as const;

export type IconName = keyof typeof ICON_PATHS;
